/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import { Oval } from 'react-loader-spinner';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as BackIcon } from '@/assets/icons/back.icon.svg';
import { ReactComponent as PlusIcon } from '@/assets/icons/plus.icon.svg';
import CurrencyyInput from '@/components/CurrencyInput';
import SearchDropdown from '@/components/SearchDropdown';
import Input from '@/components/Input/Input';
import TextArea from '@/components/TextArea/TextArea';
import { fetchVendors } from '@/services/vendorApi';
import FetchLoader from '@/components/FetchLoader';
import { createBill, generateBillNumber } from '@/services/billsApi';
import NewVendorModal from '@/pages/Vendors/components/NewVendorModal';
import { device } from '@/constants/breakpoints';
import FilePicker2 from '@/components/FilePicker2';
import FindVendorModal from './billFinancing/FindVendor';

const billFrequency = [
  { id: 1, name: 'One time', value: 'one-time' },
  { id: 1, name: 'Daily', value: 'daily' },
  { id: 2, name: 'Weekly', value: 'weekly' },
  { id: 3, name: 'Monthly', value: 'monthly' },
  { id: 3, name: 'Quarterly', value: 'quarterly' },
  { id: 3, name: 'Yearly', value: 'yearly' }
];

function NewBillForm({ showModal, setShowModal }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [showVendorForm, setShowVendorForm] = useState(false);
  const [showFindVendorModal, setShowFindVendorModal] = useState(false);
  const [vendor, setVendor] = useState({});
  const [frequency, setFrequency] = useState(billFrequency[0]);
  const [file, setFile] = useState(null);
  const [billOrInvoiceNumber, setBillOrInvoiceNumber] = useState('');
  const [expires, setExpires] = useState(false);

  const schema = yup
    .object({
      recurringStartDate: (() => {
        let validation = yup.string();
        if (frequency?.value !== 'one-time') {
          validation = validation.required('Start date is required');
        }
        return validation;
      })(),
      recurringEndDate: (() => {
        let validation = yup.string();
        if (!expires && frequency?.value !== 'one-time') {
          validation = validation.required('End date is required');
        }
        return validation;
      })(),
      amount: yup.string().required('Bill amount is required'),
      dueDate: yup.string().required('Due date is required'),
      description: yup.string().nullable(),
      billOrInvoiceNumber: yup.string().required('Bill number is required')
    })
    .required();

  const vendors = useQuery({
    queryKey: ['vendors', { page: 1, pageLimit: 1000 }],
    queryFn: fetchVendors,
    onSuccess: () => {},
    onError: () => {}
  });

  const getBillNumber = useQuery({
    queryKey: [''],
    queryFn: generateBillNumber,
    onSuccess: (data) => {
      setBillOrInvoiceNumber(data?.data?.billNumber);
    },
    onError: () => {}
  });

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors, dirtyFields }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      billOrInvoiceNumber
    }
  });

  useEffect(() => {
    reset({
      billOrInvoiceNumber
    });
  }, [billOrInvoiceNumber, reset]);

  const handleDraftBill = useMutation(createBill, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bills'] });
      navigate('/make-payments/bills?tab=draft');
      toast.success('Bill created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    }
  });

  const handleCreateBill = useMutation(createBill, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bills'] });
      navigate('/make-payments/bills?tab=approval');
      toast.success('Bill created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    }
  });

  const onSubmit = (data) => {
    const billData = {
      vendorId: vendor?.id,
      amount: data?.amount,
      frequency: frequency?.value,
      status: 'draft',
      billOrInvoiceNumber: data?.billOrInvoiceNumber,
      description: data?.description,
      dueDate: new Date(data?.dueDate).toISOString(),
      recurringStartDate: data?.recurringStartDate
        ? new Date(data?.recurringStartDate).toISOString()
        : undefined,
      recurringEndDate: data?.recurringEndDate
        ? new Date(data?.recurringEndDate).toISOString()
        : undefined,
      shouldExpireRecurring: expires ? 'no' : 'yes',
      fileUrl: file
    };

    const filteredBillData = Object.fromEntries(
      Object.entries(billData).filter(([_, v]) => v != null && v !== '')
    );

    handleDraftBill.mutate(filteredBillData);
  };

  const onSaveBill = (data) => {
    const billData = {
      vendorId: vendor?.id,
      amount: data?.amount,
      frequency: frequency?.value,
      status: 'pending-approval',
      billOrInvoiceNumber: data?.billOrInvoiceNumber,
      description: data?.description,
      dueDate: new Date(data?.dueDate).toISOString(),
      recurringStartDate: data?.recurringStartDate
        ? new Date(data?.recurringStartDate).toISOString()
        : undefined,
      recurringEndDate: data?.recurringEndDate
        ? new Date(data?.recurringEndDate).toISOString()
        : undefined,
      shouldExpireRecurring: expires ? 'no' : 'yes',
      fileUrl: file
    };

    const filteredBillData = Object.fromEntries(
      Object.entries(billData).filter(([_, v]) => v != null && v !== '')
    );

    handleCreateBill.mutate(filteredBillData);
  };

  return (
    <AnimatePresence>
      {showModal && (
        <ModalView
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="modal-overlay">
          <motion.div
            initial={{ y: 1000 }}
            animate={{ y: 0 }}
            exit={{ y: 100 }}
            transition={{ duration: 0.3 }}
            className="modal"
            onClick={(e) => e.stopPropagation()}>
            {/* ======= Content here ====== */}
            <div className="header-view">
              <button type="button" className="back" onClick={() => setShowModal(false)}>
                <BackIcon />
              </button>
            </div>

            {vendors?.isFetching || getBillNumber?.isFetching ? (
              <FetchLoader />
            ) : (
              <div className="form-view">
                <form>
                  {/* Vendor */}
                  <div className="input-view vendor">
                    <label htmlFor="vendor">Vendor</label>
                    <SearchDropdown
                      options={vendors?.data?.data?.items}
                      id="id"
                      name="companyName"
                      setValue={setVendor}
                      value={vendor}
                      placeholder="Select vendor"
                    />
                  </div>
                  <div className="add-view">
                    <button type="button" onClick={() => setShowFindVendorModal(true)}>
                      <PlusIcon /> Add new vendor
                    </button>
                  </div>
                  {/* Bill amount */}
                  <div className="input-view">
                    <label htmlFor="name">Bill amount</label>
                    <Controller
                      name="amount"
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                      render={({ field: { onChange, onBlur, value, name } }) => (
                        <CurrencyyInput
                          name={name}
                          placeholder="Enter bill amount"
                          decimalsLimit={2}
                          allowNegativeValue={false}
                          prefix="₦"
                          onValueChange={onChange}
                          value={value}
                          onBlur={onBlur}
                          error={!!errors?.amount?.message}
                          className={`currency-input ${
                            errors?.amount && dirtyFields?.amount
                              ? ' has-error'
                              : dirtyFields?.amount
                                ? 'valid'
                                : ''
                          }`}
                        />
                      )}
                    />

                    {errors?.amount && (
                      <span className="error-label">{errors?.amount?.message}</span>
                    )}
                  </div>
                  {/* Bill frequency */}

                  <div className="input-view">
                    <label htmlFor="vendor">Bill Frequency</label>
                    <SearchDropdown
                      options={billFrequency}
                      id="id"
                      name="name"
                      setValue={setFrequency}
                      value={frequency}
                      placeholder="Select frequency"
                    />
                  </div>

                  {frequency?.value !== 'one-time' && (
                    <>
                      {/* Frequency date */}
                      <div className="date-row">
                        <div className="input-view">
                          <label htmlFor="name">Start date</label>

                          <Input
                            type="date"
                            {...register('recurringStartDate')}
                            error={errors?.recurringStartDate?.message}
                          />

                          {errors?.recurringStartDate && (
                            <span className="error-label">
                              {errors?.recurringStartDate?.message}
                            </span>
                          )}
                        </div>
                        <div className="input-view">
                          <label htmlFor="name">End date</label>

                          <Input
                            type="date"
                            {...register('recurringEndDate')}
                            error={errors?.recurringEndDate?.message}
                            disabled={!!expires}
                            className={expires ? 'disabled' : ''}
                            min={watch('recurringStartDate')}
                          />

                          {errors?.recurringEndDate && (
                            <span className="error-label">{errors?.recurringEndDate?.message}</span>
                          )}
                        </div>
                      </div>

                      {/* Checkbox */}
                      <div className="checkbox-view">
                        <input
                          type="checkbox"
                          name="expires"
                          id="expires"
                          value="false"
                          className="checkbox"
                          checked={expires}
                          onChange={() => setExpires(!expires)}
                        />
                        <label htmlFor="expires">Never expires</label>
                      </div>
                    </>
                  )}

                  {/* Bill number */}
                  <div className="input-view">
                    <label htmlFor="billOrInvoiceNumber">Bill (or Invoice) no.</label>
                    <Input type="text" {...register('billOrInvoiceNumber')} />
                    <div className="input-info-view">
                      <span className="info">*Bill or invoice number is auto generated</span>
                    </div>
                    {errors?.billOrInvoiceNumber && (
                      <span className="error-label">{errors?.billOrInvoiceNumber?.message}</span>
                    )}
                  </div>
                  {/* Due date */}
                  <div className="input-view">
                    <label htmlFor="name">Due date</label>

                    <Input type="date" {...register('dueDate')} error={errors?.dueDate?.message} />

                    {errors?.dueDate && (
                      <span className="error-label">{errors?.dueDate?.message}</span>
                    )}
                  </div>
                  {/* Description */}
                  <div className="input-view">
                    <label htmlFor="description">Description</label>
                    <TextArea
                      type="number"
                      {...register('description')}
                      error={!!errors?.description?.message}
                      placeholder="Enter description"
                    />

                    {errors?.description && (
                      <span className="error-label">{errors?.description?.message}</span>
                    )}
                  </div>
                  {/* Document */}
                  <FilePicker2 file={file} setFile={setFile} acceptsPDF />
                  {/* ===== CTA ====== */}
                  <div className="cta-view">
                    <button
                      type="button"
                      className="cta-view__save"
                      onClick={handleSubmit(onSaveBill)}>
                      {handleCreateBill.isLoading ? (
                        <Oval
                          color="#FFF"
                          secondaryColor="#ddd"
                          height={30}
                          width={30}
                          strokeWidth={4}
                          ariaLabel="loading"
                        />
                      ) : (
                        'Save and request approval'
                      )}
                    </button>
                    <button
                      type="button"
                      className="cta-view__draft"
                      onClick={handleSubmit(onSubmit)}>
                      {handleDraftBill.isLoading ? (
                        <Oval
                          color="#92C22C"
                          secondaryColor="#ddd"
                          height={30}
                          width={30}
                          strokeWidth={4}
                          ariaLabel="loading"
                        />
                      ) : (
                        'Save'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            )}
          </motion.div>
        </ModalView>
      )}
      <NewVendorModal
        showModal={showVendorForm}
        setShowModal={setShowVendorForm}
        setVendor={setVendor}
      />

      <FindVendorModal
        showModal={showFindVendorModal}
        setShowModal={setShowFindVendorModal}
        showAddNewVendor={showVendorForm}
        setShowAddNewVendor={setShowVendorForm}
        setVendor={setVendor}
      />
    </AnimatePresence>
  );
}

export default NewBillForm;

const ModalView = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.colors?.white};
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: scroll;

  .modal {
    background-color: ${(props) => props.theme.colors?.white};
    z-index: 101;
    height: 100%;
    width: 1300px;
    margin: 0 auto;
    padding-top: 50px;

    @media ${device.phone} {
      width: 100%;
      padding: 0 16px;
      padding-top: 30px;
    }

    .form-view {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      margin-top: 20px;

      form {
        width: 100%;
        max-width: 460px;

        .input-view {
          width: 100%;
          margin-bottom: 30px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;

          input {
            width: 100%;
          }

          label {
            font-size: 0.875rem;
            font-weight: 400;

            span {
              font-size: 0.75rem;
              color: ${({ theme }) => theme.colors?.info};
            }
          }

          .error-label {
            font-size: 0.875rem;
            color: ${({ theme }) => theme.colors?.error};
            margin-top: 5px;
          }

          .input-info-view {
            width: 100%;
            display: flex;
            margin-top: 5px;

            span {
              font-size: 0.875rem;
              color: ${({ theme }) => theme.colors?.info};
            }
          }
        }

        .checkbox-view {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 30px;
          margin-top: 10px;

          .checkbox {
            margin-right: 5px;
            accent-color: ${({ theme }) => theme.colors?.secondary};
            cursor: pointer;
            width: 16px;
            height: 16px;
          }

          label {
            cursor: pointer;
          }
        }

        .date-row {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          .input-view {
            width: 48%;
            margin-bottom: 0px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            input {
              width: 100%;
            }

            .disabled {
              background-color: ${({ theme }) => theme.colors?.layer2};

              &::placeholder {
                color: ${({ theme }) => theme.colors?.info};
              }
            }
          }
        }

        .vendor {
          margin-bottom: 10px;
        }

        .add-view {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;

          button {
            color: ${({ theme }) => theme.colors?.secondary};
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
              margin-right: 10px;
            }
          }
        }

        .select-view {
          width: 100%;
          margin-bottom: 20px;

          label {
            font-size: 0.875rem;
            font-weight: 400;

            span {
              font-size: 0.75rem;
              color: ${({ theme }) => theme.colors?.info};
            }
          }

          .options {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 14px;

            .option {
              width: 33.333%;
              display: flex;
              align-items: center;
              cursor: pointer;

              .radio-button {
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background-color: ${({ theme }) => theme.colors?.primaryFocus};
                margin-right: 10px;

                .dot {
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                  background-color: ${({ theme }) => theme.colors?.primary};
                }
              }

              p {
                font-size: 0.875rem;
                font-weight: 400;
                color: ${({ theme }) => theme.colors?.secondary};
              }
            }
          }
        }

        .cta-view {
          width: 100%;
          display: flex;
          margin-top: 60px;
          justify-content: space-between;
          margin-bottom: 50px;

          button {
            width: 49%;
            height: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
            font-weight: 500;
            border-radius: 16px;
          }

          .cta-view__save {
            background-color: ${({ theme }) => theme.colors?.primary};
            color: ${({ theme }) => theme.colors?.white};
            margin-bottom: 20px;
            width: 69%;
          }

          .cta-view__draft {
            background-color: ${({ theme }) => theme.colors?.white};
            color: ${({ theme }) => theme.colors?.primary};
            border: 1px solid ${({ theme }) => theme.colors?.primary};
            width: 29%;
          }
        }
      }
    }
  }
`;
